import { render, staticRenderFns } from "./AdGuardDnsInfo.vue?vue&type=template&id=172332b8"
import script from "./AdGuardDnsInfo.vue?vue&type=script&lang=js"
export * from "./AdGuardDnsInfo.vue?vue&type=script&lang=js"
import style0 from "./AdGuardDnsInfo.vue?vue&type=style&index=0&id=172332b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports